export const MAX_WORK_SHIFT_DURATION_HOURS = 6

export const MATRICULE_PREFIX = 'AGD'
